/**
 * What the profiler UI does with a whole-session (`tableName === "_session"`) `table.profile_error` frame.
 *
 * Three different things arrive as that frame:
 *
 * - a profiling run that FAILED (no `code`): enter the error phase and offer Retry, exactly as always;
 * - the server's closing frame when access to the session ended (`code: "access_revoked"`: revoked, or the session is
 *   gone): enter the error phase with NO Retry (there is nothing to retry);
 * - the server's closing frame when it could not re-check access (`code: "reverify_failed"`: database trouble): the run
 *   is fine, so do NOTHING. Entering the error phase would stop the stream and the /status backstop poll, and Retry
 *   starts a SECOND run while the original keeps going. The stream hook reconnects on its own backoff.
 */

export const ACCESS_REVOKED_CODE = "access_revoked";
export const REVERIFY_FAILED_CODE = "reverify_failed";

export type SessionErrorOutcome =
  | { kind: "ignore" }
  | { kind: "error"; retryable: false | undefined };

/** `retryable: undefined` is the reducer default (Retry offered). */
export function sessionErrorOutcome(event: {
  code?: string;
}): SessionErrorOutcome {
  if (event.code === REVERIFY_FAILED_CODE) return { kind: "ignore" };
  if (event.code === ACCESS_REVOKED_CODE)
    return { kind: "error", retryable: false };
  return { kind: "error", retryable: undefined };
}
